export const GET_PAYMENT_METHODS = '@payment/GET_METHODS'

export const GET_PAYMENT_METHODS_CONFIG = '@payment/GET_METHODS_CONFIG'
export const CREATE_PAYMENT_METHODS_CONFIG = '@payment/CREATE_METHODS_CONFIG'
export const UPDATE_PAYMENT_METHODS_CONFIG = '@payment/UPDATE_METHODS_CONFIG'
export const DELETE_PAYMENT_METHODS_CONFIG = '@payment/DELETE_METHODS_CONFIG'
